"use client"

import { useProduct } from "@/contexts/product-context"
import { useActiveScope } from "@/hooks/use-active-scope"
import { coursesForProgram, programKeyOf, type ProgramKey } from "@/lib/mock/program-courses"

/** The program picked in the top selector. Nursing until someone picks another. */
export function useProgramKey(): ProgramKey {
  const { product } = useProduct()
  return programKeyOf(useActiveScope(product).child?.id)
}

export function useProgramCourses() {
  return coursesForProgram(useProgramKey())
}
